"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'trainer.upload.mode.title': '选择数据输入方法',
    'trainer.upload.mode.file': '上传CSV文件',
    'trainer.upload.mode.manual': '手动输入',
    'trainer.upload.mode.pdf': 'PDF处理',
    'trainer.upload.mode.file.description': '上传预格式化的CSV文件包含您的训练数据',
    'trainer.upload.mode.manual.description': '使用用户友好的表单界面创建训练数据',
    'trainer.upload.mode.pdf.description': '上传PDF以自动提取并从章节生成训练数据',
    'trainer.upload.title': '上传训练数据 (CSV)',
    'trainer.upload.format.required': '必需的CSV格式:',
    'trainer.upload.format.input': '提示/问题文本',
    'trainer.upload.format.output': '期望的响应/答案',
    'trainer.upload.format.category': '分类类别',
    'trainer.upload.format.optional': '可选',
    'trainer.upload.format.metadata': '支持其他元数据列并将被保留。',
    'trainer.upload.processing': '处理文件中...',
    'trainer.upload.select': '选择CSV文件',
    'trainer.upload.file.info': '文件信息',
    'trainer.upload.file.name': '文件名:',
    'trainer.upload.file.size': '大小:',
    'trainer.upload.file.type': '类型:',
    'trainer.upload.data.analysis': '数据分析',
    'trainer.upload.stats.samples': '训练样本',
    'trainer.upload.stats.input.length': '平均输入长度',
    'trainer.upload.stats.output.length': '平均输出长度',
    'trainer.upload.stats.categories': '类别',
    'trainer.upload.stats.quality': '质量分数',
    'trainer.upload.categories.found': '找到的类别:',
    'trainer.upload.preview': '数据预览 (前3行)',
    'trainer.upload.preview.input': '输入',
    'trainer.upload.preview.output': '输出',
    'trainer.upload.preview.category': '类别',
    'trainer.upload.manual.title': '手动创建训练数据',
    'trainer.upload.manual.description': '使用下面的表单逐一添加训练示例。每个示例应包含输入提示和期望的输出响应。',
    'trainer.upload.manual.input': '输入 (提示)',
    'trainer.upload.manual.input.placeholder': '输入提示或问题...',
    'trainer.upload.manual.output': '输出 (响应)',
    'trainer.upload.manual.output.placeholder': '输入期望的响应...',
    'trainer.upload.manual.category': '类别 (可选)',
    'trainer.upload.manual.category.placeholder': '输入类别标签...',
    'trainer.upload.manual.add': '添加条目',
    'trainer.upload.manual.update': '更新条目',
    'trainer.upload.manual.cancel': '取消编辑',
    'trainer.upload.manual.edit': '编辑',
    'trainer.upload.manual.delete': '删除',
    'trainer.upload.manual.list.title': '训练数据条目',
    'trainer.upload.manual.export': '导出为CSV',
    'trainer.upload.manual.validation.required': '输入和输出字段都是必需的',
    'trainer.upload.manual.export.empty': '没有训练数据可导出',
    'trainer.upload.pdf.title': 'PDF训练数据生成',
    'trainer.upload.pdf.description': '上传PDF文档以自动提取文本并生成按章节组织的训练数据。',
    'trainer.upload.pdf.upload.title': '上传PDF文档',
    'trainer.upload.pdf.select': '选择PDF文件',
    'trainer.upload.pdf.processing': '处理PDF中...',
    'trainer.upload.pdf.extracting': '提取章节中...',
    'trainer.upload.pdf.context.label': '上下文 (可选)',
    'trainer.upload.pdf.context.placeholder': '提供有关文档内容的附加上下文以提高训练数据质量...',
    'trainer.upload.pdf.extract.button': '提取章节',
    'trainer.upload.pdf.chapters.title': '提取的章节',
    'trainer.upload.pdf.chapters.select': '选择要处理的章节:',
    'trainer.upload.pdf.chapters.selectall': '全选',
    'trainer.upload.pdf.chapters.deselectall': '全不选',
    'trainer.upload.pdf.chapters.generate.button': '从选定章节生成训练数据',
    'trainer.upload.pdf.chapters.generating': '生成训练数据中...',
    'trainer.upload.pdf.chapters.preview': '预览:',
    'trainer.upload.pdf.chapters.words': '字',
    'trainer.upload.pdf.file.info': 'PDF信息',
    'trainer.upload.pdf.file.name': '文件名:',
    'trainer.upload.pdf.file.size': '大小:',
    'trainer.upload.pdf.file.pages': '页数:',
    'trainer.upload.pdf.success': '训练数据生成成功！',
    'trainer.upload.pdf.error': '处理PDF时出错。请重试。',
    'trainer.upload.pdf.error.extraction': '从PDF提取章节失败',
    'trainer.upload.pdf.error.generation': '生成训练数据失败',
    'trainer.upload.pdf.error.nofile': '请选择一个PDF文件',
    'trainer.upload.pdf.error.nochapters': '请至少选择一个章节',
};
